import { useState } from "react";
import { PaymentAttempsAPI } from "../../APIs/payment_attemps.api";
import { TeamCompetitionsAPI } from "../../APIs/team_competitions.api";
import { useCompetitions } from "../../context/CompetitionsContext";
import { Competition, CompetitionPrice } from "../../types/competition.types";
import { CompetitionsUsersBase } from "./competitions-users-base";
import { PaymentType } from "../../types/payments.types";
import { useNavigate } from "react-router-dom";

export function CompetitionsPrimaryUser() {
  const { addToast, handleError, getCompetitions } = useCompetitions();
  const [isGettingPaymentLink, setIsGettingPaymentLink] = useState(false);
  const navigate = useNavigate();

  const handleRegisterTeam = async (competition: Competition) => {
    try {
      const response = await TeamCompetitionsAPI.registerTeamToCompetition(
        competition.id
      );

      if (response.statusCode === 201) {
        addToast({
          message: `Equipo registrado en la competencia "${competition.name}"`,
          type: "success",
          location: "bottom-center",
        });

        await getCompetitions();
      } else {
        handleError(response.message);
      }
    } catch (err) {
      handleError("Error al registrar el equipo en la competencia");
    }
  };

  const handlePayment = async (
    competition: Competition,
    price: CompetitionPrice
  ) => {
    setIsGettingPaymentLink(true);
    try {
      if (price.payment_type === PaymentType.TRANSFER) {
        navigate(`/dashboard/transfer/${price.id}`);
        return;
      }

      const response = await PaymentAttempsAPI.getMercadoPagoLink(
        competition.id,
        price.id
      );

      if (response.statusCode === 200) {
        window.open(response.data.checkInUrl, "_blank");
        return;
      }

      if (response.message === "Esta inscripción ya ha sido pagada") {
        getCompetitions();
        addToast({
          message: response.message,
          type: "info",
          location: "bottom-center",
        });
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        message: "Error al obtener el link de MercadoPago",
        type: "error",
        location: "bottom-center",
      });
    } finally {
      setIsGettingPaymentLink(false);
    }
  };

  return (
    <CompetitionsUsersBase
      onRegister={handleRegisterTeam}
      onPayment={handlePayment}
      isGettingPaymentLink={isGettingPaymentLink}
    />
  );
}
